<template>
  <div>
    <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    />
    <Editor
        style="height: 300px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
        @onChange="onChange"
    />
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  name: 'newsEditor',
  components: { Editor, Toolbar },
  props: {
    content: {
      type: String,
      default: ''
    },
    // schemeId: {
    //   type: String,
    //   default: ''
    // },
    // index: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      // 富文本配置
      editor: null,
      html: '',
      // 工具栏配置
      toolbarConfig: {
        excludeKeys: ['insertImage', 'insertVideo', 'insertLink', 'uploadVideo', 'emotion', 'fullScreen'] // 去掉网络上传图片和视频
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            // 修改 uploadImage 菜单配置
            server: this.$uploadUrl + '/api/file/uploadToRichText',
            // form-data fieldName ，默认值 'wangeditor-uploaded-image'
            fieldName: 'file',
            // 继续写其他配置...
            // 【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
            headers: {
              Authorization: localStorage.getItem('token')
            },
            // 上传之前触发
            onBeforeUpload(file) {
              console.log(file)
              // file 选中的文件，格式如 { key: file }
              return file
            },
            onSuccess(file, res) {
              console.log(`${file.name} 上传成功`, res)
            },
            // 单个文件上传失败
            onFailed(file, res) {
              console.log(`${file.name} 上传失败`, res)
            },
            // 上传错误，或者触发 timeout 超时
            onError(file, err, res) {
              console.log(`${file.name} 上传出错`, err, res)
            },
            customInsert(result, insertFn) {
              // result是返回的json格式
              // 从 result 中找到 url alt href ，然后插图图片
              // result = {
              //   'errno': 0, // 注意：值是数字，不能是字符串
              //   'data': {
              //     'url': 'http://scheme.obs.cn-sdqd1.ctyun.cn/93643cde4c6a4d20a6087883b3124f58.jpeg', // 图片 src ，必须
              //     'alt': 'yyy', // 图片描述文字，非必须
              //     'href': 'zzz' // 图片的链接，非必须
              //   }
              // }
              console.log(result)
              insertFn(result.data.url, result.data.alt, result.data.href)
            },
          }
        }
      },
      mode: 'default'
    }
  },
  mounted() {
    // this.schemeDeatil()
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      console.log(this.data)
      let params = {
        editor: this.editor
      }
      this.$emit('editEvent', params)
      // console.log(this.editor.getAllMenuKeys())
      this.editor.setHtml(this.content)
    },
    onChange() {
      this.html = this.editor.getHtml()
      let params = {
        richText: this.html
      }
      this.$emit('childEvent', params)
    }
  }
}
</script>

<style scoped>

</style>
